module.exports = __webpack_public_path__ + "img/cross.47dd2764.svg";